/* global CONTENT_TARGETS, animations, CONTENT, runningMode, loadingBar, NaN, urlParams, componentHandler, snackbar, loginMenu, CONTENT_TARGET, buildNumber, globalData, Network */

/**
 * Updates all fields of an object existing in data.
 * Can also be used to delete multiple fields of an object.
 * @param {Object} obj
 * Object to manipulate.
 * @param {Object} data
 * Data to update.
 * @param {Boolean} deleteOnNull
 * <code>true</code>: If field <i>i</i> in data is <code>null</code>,
 * field <i>i</i> in obj will be deleted.
 * @returns {Object}
 * Updated Object.
 */
function updateObjectFields(obj, data, deleteOnNull) {
  if (typeof obj !== "object") {
    console.error("obj is not an object");
    console.log(obj);
    return obj;
  }
  if (typeof data !== "object") {
    console.error("data is not an object");
    console.log(data);
    return obj;
  }
  //duplicate code. But a little faster.
  if (deleteOnNull) {
    for (var i = 0, keys = Object.keys(data); i < keys.length; i++) {
      if (data[keys[i]] === null) delete obj[keys[i]];
      obj[keys[i]] = data[keys[i]];
    }
    return obj;
  }
  for (var i = 0, keys = Object.keys(data); i < keys.length; i++)
    obj[keys[i]] = data[keys[i]];
  return obj;
}

/**
 * Collects and stores the GET parameter from URL
 * @type object
 */
var urlParams = {
  /**
   * GET Parameter as object. <i>null</i> if <i>getUrlParams</i> was not
   * called yet.
   * @type null|object
   */
  data: null,
  /**
   * Collects GET parameter from Url and stores it in <i>data</i>
   * @returns {undefined}
   */
  init: function () {
    this.data = URIToObject(window.location.search);
  },
};

/**
 * Convert object to urlencoded string. Nested Objects are allowed.
 * @param {objet} object
 * @param {string} prefix
 * Only for recursive call
 * @returns {String}
 * Can be used for GET. Without <i>?</i>
 */
function objectToURI(object, prefix) {
  var str = [];
  for (var i in object) {
    var key = prefix ? prefix + "[" + i + "]" : i,
      value = object[i];
    switch (typeof value) {
      case "object":
        //check if object is from CONTENT (expensive Operation)
        //this is needed cause of the length of CONTENT objects
        //views expecting view pointer should be able to parse string to view
        var possibleViewName = (function () {
          for (var i in CONTENT) {
            if (CONTENT[i] === value) return i;
          }
          return null;
        })();
        if (possibleViewName !== null) {
          value = possibleViewName;
          str.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
          continue;
        }
        //continue;
        //recursive call
        str.push(objectToURI(value, key));
        break;
      case "function":
        continue;
      case "undefined":
        str.push(encodeURIComponent(key));
        break;
      default:
        str.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    }
  }
  return str.join("&");
}

/**
 * Converts GET parameter to an object. Nested values are posible.
 * Parsing ob int, float and bool. Removes possible <i>?</i> on begin.
 * @param {string} URI
 * @returns {object}
 */
function URIToObject(URI) {
  if (URI === "") return {};

  var array = decodeURIComponent(URI);
  if (array[0] === "?") array = array.substr(1);
  array = array.split("&");
  var result = {};
  for (var i = 0, len = array.length; i < len; i++) {
    var item = array[i].split("=");
    var value = item[1];
    var key = item[0];
    var lastInserted = result;
    var valueTarget;

    //create object structure
    do {
      //get first key
      var splitIndex = key.indexOf("[");
      if (splitIndex === 0) {
        //first key is surrounded with []
        splitIndex = key.indexOf("]") + 1;
      } else if (splitIndex === -1) {
        //no key is surrounded with []
        splitIndex = key.length;
      }

      var keyToInsert = key.substr(0, splitIndex);
      if (keyToInsert.indexOf("[") > -1) {
        //first key is surrounded with []
        keyToInsert = keyToInsert.substr(1, keyToInsert.length - 2);
      }

      //remove pulled key
      key = key.substr(splitIndex);

      //check if object already exists
      if (lastInserted[keyToInsert] === undefined)
        //create new key with empty object in last inserted object
        lastInserted[keyToInsert] = {};

      valueTarget = {
        obj: lastInserted,
        key: keyToInsert,
      };
      lastInserted = lastInserted[keyToInsert];
    } while (key !== "");

    //try to parse value
    switch (value) {
      case "true":
        value = true;
        break;
      case "false":
        value = false;
        break;
      default:
        //float and int
        if (isFinite(value)) value = parseFloat(value);
        if (value === parseInt(value)) value = parseInt(value);
        if (value === NaN) value = "";
    }

    //add value to object
    valueTarget.obj[valueTarget.key] = value;
  }
  return result;
}

function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || "";
  sliceSize = sliceSize || 512;

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

/**
 * Compares subject with datatypes and struture with model. Prints error message.
 * @param {object} model
 * Propertys with should not be checked deeper, schuld be set to <i>undefined</i>.<br/>
 * Objects and Arrays with should not be checked deeper, schuld be empty.
 * @param {object} subject
 * @param {boolean} nestedCall
 * For internal recursive use only. If <i>true</i> no error message will be
 * print on console.
 * @returns {String|Boolean}
 * Boolen on external use.
 */
function validateObject(model, subject, nestedCall) {
  var subjectKeys = subject ? Object.keys(subject) : []; //because of null
  var modelKeys = Object.keys(model);

  //Empty object in model should not be checked
  if (modelKeys.length === 0) return true;

  //serach for missing propetries
  var missing = [];
  for (var i = 0, len = modelKeys.length; i < len; i++) {
    var key = modelKeys[i];
    if (subjectKeys.indexOf(key) < 0) {
      missing.push(key);
    }
  }
  if (missing.length > 0)
    return exit(
      (nestedCall ? nestedCall + "::" : "") +
        ": Properties missing: " +
        missing.join(", "),
      nestedCall
    );

  //search for additional propetries
  //if length is the same, keys are equal
  if (subjectKeys.length !== modelKeys.length) {
    var tooMuch = [];
    for (var i = 0, len = subjectKeys.length; i < len; i++) {
      var key = subjectKeys[i];
      if (modelKeys.indexOf(key) < 0) {
        tooMuch.push(key);
      }
    }
    if (tooMuch.length > 0)
      return exit(
        (nestedCall ? nestedCall + "::" : "") +
          ": Properties not allowed: " +
          tooMuch.join(", "),
        nestedCall
      );
  }

  //check values
  for (var i = 0, len = subjectKeys.length; i < len; i++) {
    var key = subjectKeys[i];
    var valueResult = checkValue(model[key], subject[key]);
    if (valueResult !== true)
      return exit(
        (nestedCall ? nestedCall + "::" : "") + valueResult,
        nestedCall
      );
  }

  return true;

  /**
   * Compares datatypes between model an subject. Calls recurive <i>objectValidator</i>
   * and self on objects and arrays.
   * @param {number|object|boolean|string|undefined} model
   * @param {number|object|boolean|string|undefined} subject
   * @returns {String|Boolean}
   */
  function checkValue(model, subject) {
    //if value in model is undefined, ignore subjects content
    if (model === undefined) return true;

    if (model === null) {
      if (subject === null) return true;
      return exit(key + " has to be null", nestedCall);
    }

    //check datatype
    if (typeof model !== typeof subject) {
      return exit(
        key + " is " + typeof subject + ", but should be " + typeof model,
        nestedCall
      );
    }

    //check objects (and arrays)
    if (typeof model === "object") {
      if (Array.isArray(model)) {
        if (!Array.isArray(subject))
          return exit(key + " is object, but should be an array", nestedCall);

        var modelValue = model[0];

        //Empty array in model should not be checked
        if (modelValue === undefined) return true;

        //recursive check of arrays
        for (var j = 0, len2 = subject.length; j < len2; j++) {
          //check each item in array
          var valueResult = checkValue(modelValue, subject[j]);
          if (valueResult === true) continue;

          var arr = valueResult.split("::");
          //because of first key in message is now double, remove it
          arr.shift();
          //add array index to error message
          arr[arr.length - 2] += "[" + j + "]";
          valueResult = arr.join("::");
          //remove the last ::
          valueResult = valueResult.replace("]::", "]");
          return exit(valueResult, nestedCall);
        }
      } else {
        if (Array.isArray(subject))
          return exit(key + " is array, but should be an object", nestedCall);

        //recursive check of objects
        var resultOfObject = validateObject(
          model,
          subject,
          nestedCall + "::" + key
        );
        if (resultOfObject !== true) return exit(resultOfObject, true);
      }
    }
    return true;
  }

  /**
   * Returns <i>str</i> if <i>nestedCall</i> is <i>true</i>. <i>false</i> else.
   * @param {string} str
   * @param {boolen} nestedCall
   * @returns {Boolean}
   */
  function exit(str, nestedCall) {
    if (nestedCall) return str;
    console.error(str);
    return false;
  }
}

/**
 * Converts an float to string suffixing " €" with ',' as seperator.
 * @param {Number} input
 * @returns {String}
 */
function formatMoney(input) {
  input = parseFloat(input);
  return input.toFixed(2).toString().replace(".", ",") + " €";
}

/**
 * Converts an number (float) to a daytime in p.m. scheme.
 * @param {number|string} input
 * parseFloat should returns an valid number on this value
 * @returns {String|Boolean}
 * <code>false</code> on error.
 */
function floatToTime(input) {
  input = parseFloat(input);

  if (input === NaN || typeof input !== "number" || input < 0 || input > 24)
    return false;

  var str = "";
  str += parseInt(input);
  str += ":";

  //get Minutes
  var floatMinutes = input - parseInt(input);
  var minutes = parseInt(60 * floatMinutes);
  str += minutes < 9 ? "0" + minutes : minutes;

  return str;
}

/**
 * Converts an time string hh:mm to an float
 * @param {string} string
 * @returns {timeToFloat.float|Boolean}
 * <code>false</code> on error.
 */
function timeToFloat(string) {
  if (typeof string !== "string") return false;

  var array = string.split(":");

  if (array.length !== 2) return false;

  var float = parseInt(array[0]);

  //minutes
  var minutes = parseInt(array[1]) / 60;
  float += parseFloat(minutes.toFixed(2));

  return float;
}

/**
 * Converts an date string in format dd.mm.yyyy to an ISODate yyyy-mm-dd
 * @param {string} string
 * dd.mm.yyyy
 * @returns {string}
 * yyyy-mm-dd<br/>
 * original on error
 */
function dateToISODate(string) {
  if (typeof string !== "string") return false;

  var array = string.split(".");

  if (!Array.isArray(array) || array.length !== 3) return string;

  return array[2] + "-" + array[1] + "-" + array[0];
}

/**
 * Beautifies date string
 * @param {string} dateString
 * dd.mm.yyyy | yyyy-mm-dd
 * @returns {String}
 * <i>heute</i> | <i>am 01.10.2015</i> ..
 */
function getDateString(dateString) {
  //ISO-Date given?
  if (dateString.split("-").length === 3) {
    var localDateArray = dateString.split("-");
    dateString =
      localDateArray[2] + "." + localDateArray[1] + "." + localDateArray[0];
  }

  var todayDate = new Date();

  var dateArray = [
    todayDate.getDate(),
    todayDate.getMonth() + 1,
    todayDate.getFullYear(),
  ];

  if (parseInt(dateArray[0]) < 10) dateArray[0] = "0" + dateArray[0];
  if (parseInt(dateArray[1]) < 10) dateArray[1] = "0" + dateArray[1];

  todayDate = dateArray.join(".");

  if (todayDate === dateString) return " heute";
  else return " am " + dateString;
}

/**
 * Convert an ISO-Datetime string to an German datetime string
 * @param {String} ISODate
 * @returns {String}
 */
function ISODateTimeToDateTimeString(ISODate) {
  var date = new Date(ISODate);
  return (
    date.getDate() +
    "." +
    (date.getMonth() + 1) +
    "." +
    date.getFullYear() +
    " " +
    date.getHours() +
    ":" +
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes())
  );
}

/**
 * Convert an ISO-Datetime string to an German date string
 * @param {String} ISODate
 * @returns {String}
 */
function ISODateToDateString(ISODate) {
  var date = new Date(ISODate);
  return (
    date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear()
  );
}

/**
 * Returns a nice string with the number of persons
 * @param {string} n
 * @returns {string}
 */
function getPersonString(n) {
  if (parseInt(n) === 1) return "eine Person";
  else return n + " Personen";
}

/* ----------- Framework functions END ------------- */

/**
 * Convert a snake case sting to a camel case string.
 * @param {string} string
 * @returns {string}
 */
function snakeCaseToCamelCase(string) {
  let i;
  while ((i = string.indexOf("_")) !== -1)
    string =
      string.substr(0, i) +
      string.substr(i + 1, 1).toUpperCase() +
      string.substr(i + 2);

  return string;
}

function camelCaseToSnakeCase(string) {
  const result = [];

  for (let i = 0, len = string.length; i < len; i++) {
    const char = string[i];
    const newChar = char.toUpperCase();

    if (char === newChar && i !== 0) result.push("_");
    result.push(newChar);
  }
  return result.join("");
}

function getFunctionsForType(type, object, key) {
  switch (type) {
    case "location":
      return [
        {
          name: "Mit Adresse exportieren",
          function: "withAddress",
        },
      ];
    case "date":
      return [
        {
          name: "Datum (01.01.2019)",
          function: "DD.MM.YYYY",
        },
        {
          name: "Datum (01012019)",
          function: "DDMMYYYY",
        },
        {
          name: "Datum (2019-01-01)",
          function: "YYYY-MM-DD",
        },
        {
          name: "Uhrzeit (15:21)",
          function: "HH:mm",
        },
        {
          name: "Uhrzeit (15:21:30)",
          function: "HH:mm:ss",
        },
        {
          name: "Datum + Uhrzeit (TT.MM.JJJJ 00:00:00)",
          function: "DD.MM.YYYY HH:mm:ss",
        },
      ];
    case "raffle":
      return [
        {
          name: "Wert durch X ersetzen",
          function: "X",
        },
        {
          name: "Wert durch JA / NEIN ersetzen",
          function: "YES-NO",
        },
        {
          name: "Eigenen Wert eintragen",
          function: "dynamicFunctionValue",
        },
      ];
    case "address":
      const keyParts = key.split("."); //currently max length is 2
      if (
        (keyParts.length >= 2 && keyParts[1] === "houseNumber") ||
        keyParts[1] === "houseNumberExtra"
      ) {
        return [
          {
            name: "Hausnummer + Zusatz (ohne Leerzeichen)",
            function: "houseNumberhouseNumberExtra", // additive = Zusatz (engl.)
          },
          {
            name: "Hausnummer + Zusatz (mit Leerzeichen)",
            function: "houseNumber houseNumberExtra", // additive = Zusatz (engl.)
          },
        ];
      } else if (keyParts.length >= 2 && keyParts[1] === "street") {
        return [
          {
            name: "Straße Hausnummer + Zusatz (ohne Leerzeichen)",
            function: "street houseNumberhouseNumberExtra",
          },
          {
            name: "Straße Hausnummer + Zusatz (mit Leerzeichen)",
            function: "street houseNumber houseNumberExtra",
          },
          {
            name: "Straße/Hausnummer/Zusatz",
            function: "street/houseNumber/houseNumberExtra",
          },
        ];
      } else return [];
    case "tel":
      return [
        {
          name: "Format: 042112345",
          function: "format_number",
        },
        {
          name: "Format: 0421 / 12345",
          function: "format_number_slash",
        },
        {
          name: "Format: 0421 - 12345",
          function: "format_number_hyphen",
        },
        {
          name: "Format: +49 42112345",
          function: "format_number_country",
        },
        {
          name: "Format: +49 421 / 12345",
          function: "format_number_country_slash",
        },
        {
          name: "Format: +49 421 - 12345",
          function: "format_number_country_hyphen",
        },
      ];
    case "default":
    case "text":
      let firstnamesArray = ["vorname", "vname"];
      let lastnamesArray = ["nachname", "zuname", "zname"];
      let functionsArray = [];
      if (object && object.data && object.data.length > 0) {
        object.data.forEach((data) => {
          if (data.name.includes(key) || key.includes(data.name)) {
            if (
              firstnamesArray.some((substring) =>
                data.name.includes(substring)
              ) ||
              lastnamesArray.some((substring) => data.name.includes(substring))
            ) {
              functionsArray = getFirstnameLastNameFunctions();
            } else if (data.type === "tel") {
              console.log("IS TYPE TEL !!", object);
              functionsArray = [
                {
                  name: "Format: 042112345",
                  function: "format_number",
                },
                {
                  name: "Format: 0421 / 12345",
                  function: "format_number_slash",
                },
                {
                  name: "Format: 0421 - 12345",
                  function: "format_number_hyphen",
                },
                {
                  name: "Format: +49 42112345",
                  function: "format_number_country",
                },
                {
                  name: "Format: +49 421 / 12345",
                  function: "format_number_country_slash",
                },
                {
                  name: "Format: +49 421 - 12345",
                  function: "format_number_country_hyphen",
                },
              ];
            }
          }
        });
        return functionsArray;
      } else if (
        (object &&
          object.label &&
          object.label.toLowerCase().indexOf("vorname") >= 0) ||
        (object &&
          object.label &&
          object.label.toLowerCase().indexOf("nachname") >= 0) ||
        firstnamesArray.some(
          (substring) =>
            object && object.label && object.label.includes(substring)
        ) ||
        lastnamesArray.some(
          (substring) =>
            object && object.label && object.label.includes(substring)
        )
      ) {
        functionsArray = getFirstnameLastNameFunctions();

        return functionsArray;
      } else {
        return [
          {
            name: "Wert durch X ersetzen",
            function: "X",
          },
          {
            name: "Wert durch JA / NEIN ersetzen",
            function: "YES-NO",
          },
          {
            name: "Eigenen Wert eintragen",
            function: "dynamicFunctionValue",
          },
        ];
      }
    default:
      return [];
  }
}

function getGermanWeekday(weekday) {
  switch (weekday) {
    case "monday":
      return "montag";
    case "tuesday":
      return "dienstag";
    case "wednesday":
      return "mittwoch";
    case "thursday":
      return "donnerstag";
    case "friday":
      return "freitag";
    case "saturday":
      return "samstag";
    case "sunday":
      return "sonntag";
  }
}

function createSchemaNode(text, key) {
  const schemaNode = document.createElement("table");
  schemaNode.draggable = true;
  schemaNode.classList.add("item");
  schemaNode.classList.add("input");
  schemaNode.classList.add("mdl-shadow--2dp");
  schemaNode.text = text;
  schemaNode.key = key;

  return schemaNode;
}

function getFirstnameLastNameFunctions() {
  return [
    {
      name: "Vorname Nachname",
      function: "firstname lastname",
    },
    {
      name: "Nachname Vorname",
      function: "lastname firstname",
    },
    {
      name: "Vorname, Nachname",
      function: "firstname, lastname",
    },
    {
      name: "Nachname, Vorname",
      function: "lastname, firstname",
    },
  ];
}

function createSign(path) {
  var canvas = document.createElement("canvas");

  path = path.split(",");
  path = path.map((i) => (i === "x" ? i : i.split(":")));

  var borders = getBorders(path);

  canvas.width = borders.maxX - borders.minX;
  canvas.height = borders.maxY - borders.minY;
  path = path.map((i) =>
    i === "x" ? i : [i[0] - borders.minX, i[1] - borders.minY]
  );

  var ctx = canvas.getContext("2d");
  var lastPoint = null;
  path.map((p) => {
    if (p === "x") {
      lastPoint = null;
      return;
    }

    var currentPoint = {
      x: p[0],
      y: p[1],
    };

    if (!lastPoint) {
      ctx.beginPath();
      ctx.moveTo(currentPoint.x, currentPoint.y);
      ctx.stroke();
    } else {
      ctx.lineTo(currentPoint.x, currentPoint.y);
      ctx.stroke();
    }

    lastPoint = currentPoint;
  });

  return canvas;

  function getBorders(pathArr) {
    pathArr = pathArr.filter((i) => i !== "x");

    var minX = 10000;
    var minY = 10000;
    var maxX = -1;
    var maxY = -1;

    pathArr = pathArr.map((i) => {
      minX = Math.min(minX, i[0]);
      minY = Math.min(minY, i[1]);
      maxX = Math.max(maxX, i[0]);
      maxY = Math.max(maxY, i[1]);
    });

    return {
      minX: minX,
      minY: minY,
      maxX: maxX,
      maxY: maxY,
    };
  }
}

/**
 * Traverses the dom up from the given elem until a element is found that matches the selector.
 * Considers the elem for matching too.
 */
function closest(elem, selector) {
  while (!elem.matches(selector)) {
    elem = elem.parentElement;
    if (!elem) {
      return null;
    }
  }
  return elem;
}
